import axios from 'axios';
import { gql } from 'apollo-boost';

export const RETRIEVE_MARKETING_CAMPAIGNS_QUERY = gql`
  query retrieveMarketingCampaign($uuid: String){    
    retrieveMarketingCampaign(uuid: $uuid){
        uuid
        batch_name
        sender,
        email_template_id
        email_template_variables
        text_content
        text_content_variables 
        push_content
        push_content_header
        push_content_variables
        scheduled_time
        cron_schedule
        column_names
        created_at
        updated_at
        status
        scheduled_by
    }
  }
`;

export const RETRIEVE_RECIPIENTS_UPLOAD_LINK = gql`
query retrieveRecipientsUploadLink($uuid: String!){    
  retrieveRecipientsUploadLink(uuid: $uuid){
      url
  }
}
`;

export const RETRIEVE_CAMPAIGN_METRICS = gql`
  query retrieveMarketingCampaignMetrics($uuid: String, $page: Int, $refresh: Boolean) {
    retrieveMarketingCampaignMetrics(uuid: $uuid, page: $page, refresh: $refresh) {
      campaigns {
        batch_name
        uuid
      }
      metrics {
        batch_name
        created_at
        updated_at
        has_email
        has_text
        email_sent
        email_failed
        email_deferred
        email_bounce
        email_spamreport
        email_unsubscribe
        email_delivered
        email_open
        email_click
        email_dropped
        email_blocks
        sms_delivered
        sms_undelivered
        sms_sent
        sms_failed
      }
      page
      maxPage
    }
  }
`;

export const streamUploadFile = async (url, file) => {
  try {
    const formData = new FormData();
    formData.append("data", file);

    const { data } = await axios({
      method: "PUT",
      url,
      headers: {
        'Content-Type': 'text/csv',
      },
      data: file,
    });

    return data;
  } catch (err) {
    return err;
  }
};